/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {}
